import React from 'react';

import { ITableModel } from '../interface';
import { IMissingLetters } from 'models/MissingLetter';

import Text from 'components/Text';
import ModelButton from 'components/ModelButton';
import iconDownload from 'img/icon-download.svg';

import DownloadService from 'services/download.service';

const _downloadService = new DownloadService();

const downloadButton = ModelButton(
  'Arquivo',
  iconDownload,
  (data: IMissingLetters) =>
    _downloadService.OpenFileFromMissingLetter(data.id),
  undefined,
  60
);

const labelVigency = {
  label: 'Vigência',
  key: 'startDate',
  size: 240,
  maxSize: 240,
  Component: (data: IMissingLetters) => (
    <Text
      size={12}
      className="color-blue-gray text-wrap"
      showTip
      showTipContent={`${new Date(
        data.startDate
      ).toLocaleDateString()} a ${new Date(data.endDate).toLocaleDateString()}`}
    >
      {new Date(data.startDate).toLocaleDateString()} a{' '}
      {new Date(data.endDate).toLocaleDateString()}
    </Text>
  ),
};

const labelCode = {
  label: 'Código',
  key: 'product.code',
  size: 80,
  maxSize: 80,
};

const labelEnterprise = {
  label: 'Empresa',
  key: 'product.enterpriseName',
  size: 100,
  maxSize: 100,
};

const labelCategory = {
  label: 'Categoria',
  key: 'product.category',
  size: 150,
  maxSize: 150,
};

const labelProduct = {
  label: 'Produto',
  key: 'product.name',
};

const labelSubstance = {
  label: 'Substância',
  key: 'product.substance',
  size: 160,
  maxSize: 160,
};

const labelSupplier = {
  label: 'Fornecedor',
  key: 'product.supplier',
  size: 120,
};

const missingLetterModel: Array<ITableModel> = [
  labelCode,
  labelCategory,
  labelProduct,
  labelEnterprise,
  labelSubstance,
  labelSupplier,
  labelVigency,
  downloadButton,
];

export { missingLetterModel };
